import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";


// Config for AWS Cognito authentication (Lactalis tenant setup)

const cognitoAuthConfig = {
  authority:
    "https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_ly5xUVaHX", // ly5xUVaHX - lactalis, brAkmJJ1v - shorelinq
  client_id: "2q4geajrbmpv962p3bfc6djhsj", // 2q4geajrbmpv962p3bfc6djhsj  - lactalis,  4ob5m90ej34hpc8mc7d0ndop0h - shorelinq
  redirect_uri: "https://downtime-lactalis.clevvi.com.au",
  response_type: "code",
  scope: "email openid phone",
};

const root = ReactDOM.createRoot(document.getElementById("root"));
// Render the app inside React's strict mode and AuthProvider for OIDC handling
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
